/*
 * Copyright (c) 2022. American Express Company
 */

import React from 'react';
import { ButtonPrimary, ButtonSecondary, IconMedal } from '@americanexpress/dls-react';

import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import Card from 'src/components/atomic/atoms/card/Card';
import colors from 'src/styles/colors.module.scss';
import vars from 'src/styles/variables.module.scss';
import LiteralsService from 'src/services/literals/LiteralsService';

import { props } from 'src/types/view-models/suggestion.view.model';
import bgColors from 'src/styles/bgColors.module.scss';
import styles from './suggestion.module.scss';

/**
 * Override DLS
 * Manual styles are needed to overwrite the DLS component
 * ideally classes should work but the DLS component doesn't handle this correctly
 */
const buttonPrimaryStyle = { backgroundColor: 'transparent', borderColor: vars.actionLightDefault };
const buttonSecondaryStyle = { backgroundColor: 'transparent', color: vars.actionLightDefault };

export default function Suggestion({ variant }: props): JSX.Element {
    let preTitle: string, title: string, body: string, buttonPrimaryText: string, buttonSecondaryText: string;

    switch (variant) {
        case 'refinance':
            preTitle = LiteralsService.getLiteral('Insights.suggestion.preTitle');
            title = LiteralsService.getLiteral('Insights.suggestion.refinanceYourDebt');
            body = LiteralsService.getLiteral('Insights.suggestion.body');
            buttonPrimaryText = LiteralsService.getLiteral('Insights.suggestion.positive');
            buttonSecondaryText = LiteralsService.getLiteral('Insights.suggestion.dismiss');
            break;
        case 'connectAccounts':
            preTitle = LiteralsService.getLiteral('Insights.suggestion.preTitle');
            title = LiteralsService.getLiteral('Insights.suggestion.connectYourOnlineAccounts');
            body = LiteralsService.getLiteral('Insights.suggestion.body');
            buttonPrimaryText = LiteralsService.getLiteral('Insights.suggestion.addAccount');
            buttonSecondaryText = LiteralsService.getLiteral('Insights.suggestion.dismiss');
            break;
    }

    return (
        <Card className={bgColors.brand}>
            <div className={styles.inline}>
                <IconMedal style={{ fill: vars.textLight }} />
                <Typography variant={TypographyVariants.HEADING_XS} className={colors.textLight}>
                    {preTitle}
                </Typography>
            </div>
            <Typography variant={TypographyVariants.HEADING_M} className={colors.textLight}>
                {title}
            </Typography>
            <Typography variant={TypographyVariants.BODY} className={colors.textLight}>
                {body}
            </Typography>
            <div className={styles.inline}>
                <ButtonPrimary style={buttonPrimaryStyle}>{buttonPrimaryText}</ButtonPrimary>
                <ButtonSecondary style={buttonSecondaryStyle}>{buttonSecondaryText}</ButtonSecondary>
            </div>
        </Card>
    );
}
